import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getRecomended = createAsyncThunk(
  'recomended/getRecomended',
  async () => {
    const recomended = await instanceAPI.get('/get-recommended-auctions')
      .then((resp) => resp.data.recommendedAuctions);
    return recomended;
  },
);

const recomendedSlice = createSlice({
  name: 'recomended',
  initialState: {
    recomended: [],
    status: null,
  },
  extraReducers: {
    [getRecomended.pending]: (state) => {
      state.status = 'loading';
    },
    [getRecomended.fulfilled]: (state, action) => {
      state.status = 'success';
      state.recomended = action.payload;
    },
    [getRecomended.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default recomendedSlice.reducer;
